import {FADE_MAX, FADE_MIN} from './constants.js'

export function fmt (time) {
	if (!isFinite(time) || time < 0) time = 0;
	const m = Math.floor(time / 60);
	const s = time - m * 60;
	return ("0" + m).slice(-2) + ":" + (s < 10 ? "0" : "") + s.toFixed(1);
}

export function round (v) {
	return Math.round(v * 100) / 100;
}

// Items from older projects may lack transitions; they default to a cut
export function in_transition (item) {
	return item.transition || {type: "cut", duration: 1};
}

export function out_transition (item) {
	return item.transition_out || {type: "cut", duration: 1};
}

export function clamp_fade (value) {
	return _.clamp(value, FADE_MIN, FADE_MAX);
}

// Opacity factor for an item with in/out fades at time t
export function fade_factor (item, start, end, t) {
	const tin = in_transition(item);
	const tout = out_transition(item);
	const len = end - start;
	const fin = tin.type == "fade" && tin.duration > 0 ? _.clamp((t - start) / Math.min(tin.duration, len), 0, 1) : 1;
	const fout = tout.type == "fade" && tout.duration > 0 ? _.clamp((end - t) / Math.min(tout.duration, len), 0, 1) : 1;
	return fin * fout;
}

// Qualities are ordered best first, so the last one is the lightest; export always uses clip.url
export function preview_url (clip, low) {
	if (!low || !clip.qualities || !clip.qualities.length) return clip.url;
	return _.last(clip.qualities).url || clip.url;
}

// Waveform is read from the lightest quality; every quality carries the same audio
export function wave_url (clip) {
	return (clip.qualities && clip.qualities.length && _.last(clip.qualities).url) || clip.url;
}

// Writes only on change so per-frame updates don't cause extra style recalculation
export function set_style (el, prop, value) {
	const v = String(value);
	if (el.style[prop] !== v) el.style[prop] = v;
}
